// Barre d'avancement du cycle de vente.
// `stage` = index de l'étape courante (0 Devis … 4 Payée) ; stage=5 = tout terminé.
// `compact` : version dense (pastilles seules, sans libellés) pour les lignes de liste.

const STEPS = ['Devis', 'Commande', 'Livrée', 'Facturée', 'Payée'];

/**
 * Une vente transcrite d'un email par l'agent N'EST PAS un devis : le client ne
 * l'a pas proposée, il l'a reçue. L'appeler « Devis » le perturbait — elle se
 * nomme donc « Commande » dès la première étape, et « Confirmée » une fois
 * validée (2026-10-28).
 */
const STEPS_AGENT = ['Commande', 'Confirmée', 'Livrée', 'Facturée', 'Payée'];

export default function Stepper(
  { stage, compact = false, source }: { stage: number; compact?: boolean; source?: 'agent' | 'manuel' },
) {
  const steps = source === 'agent' ? STEPS_AGENT : STEPS;
  return (
    <ol className={`stepper${compact ? ' compact' : ''}`} aria-label="Avancement de la vente">
      {steps.map((label, i) => {
        const cls = i < stage ? 'done' : i === stage ? 'current' : 'todo';
        return (
          <li key={label} className={`step ${cls}`} title={compact ? label : undefined}>
            <span className="step-dot">{i < stage ? '✓' : i + 1}</span>
            {!compact && <span className="step-label">{label}</span>}
          </li>
        );
      })}
    </ol>
  );
}
